// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".section-title[data-v-0c9bd93a]{position:relative}.section-title[data-v-0c9bd93a]:before{content:\"\";width:150px;height:1px;background:var(--v-primary-base);position:absolute;bottom:0;right:0}", ""]);
// Exports
module.exports = exports;
